import BaseService from "../base.service";

const VUE_APP_API_URL = process.env.VUE_APP_API_URL;

class IndexService extends BaseService {
  getGameMarket() {
    return this.get(`${VUE_APP_API_URL}/api/games-markets`).then(
      ({ data }) => data
    );
  }

  getLastestResults() {
    return this.get(`${VUE_APP_API_URL}/api/latest-results`).then(
      ({ data }) => data
    );
  }

  getLastestResultsByGame(limit: number, game: string, date: string) {
    const params = [];

    if (limit) params.push(`limit=${limit}`);
    if (game) params.push(`game=${game}`);
    if (date) params.push(`date=${date}`);

    const apiUrl = `${VUE_APP_API_URL}/api/latest-results-by-game${
      params.length > 0 ? "?" + params.join("&") : ""
    }`;

    return this.get(apiUrl).then(({ data }) => data);
  }

  getNextDraws() {
    return this.get(`${VUE_APP_API_URL}/api/next-draws`).then(
      ({ data }) => data
    );
  }
}
export default new IndexService();
